<script setup>
/* eslint-disable */
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';


import { usePreSportsStore } from '@/stores/pre_sports';
import { useLiveSportsStore } from '@/stores/live_sports';
import QuickPicks from './QuickPicks.vue';
import { useSocketStore } from '@/stores/socket';
import { useLaternaStore } from '@/stores/laterna';
const preSportsStore = usePreSportsStore();
const liveSportsStore = useLiveSportsStore();
const section_sports = ref([]);
const selectedSport = ref(null);

const common_sports = ref([]);
const props = defineProps({
	section: {
		type: Object,
		required: true,
	},
})

const changeSport = (sport) => {
	selectedSport.value = sport;
};

function getCommonSports() {
	const ids = new Set(preSportsStore.preSports.map(item => item.id));
	common_sports.value = section_sports.value.filter(item => ids.has(item.id));

	return common_sports.value;
}

onMounted(async () => {
	section_sports.value = await useLaternaStore().fetchLandingSectionItems(props.section.id);
    if (preSportsStore.preSports.length > 0) {
		selectedSport.value = getCommonSports()[0];
    }
});

const filteredSports = computed(() => {
	return common_sports.value;
});


watch(() => preSportsStore.preSports, (newSports, oldSports) => {
	if (oldSports.length > 0) return;
    selectedSport.value = getCommonSports()[0];
}, {deep: true})

</script>

<template>
<div class="eee-eimai-div">

    <div class="container-sm">
        <div class="popular-games-bar">
            <div class="popular-left">
                 <img v-if="props.section.media" :src="props.section.media?.path" class="popular-icon"/>
                <span class="popular-title">{{ section.title }} </span>
            </div>

            <div class="popular-right">
                <div class="sport-icons">
                    <template  v-for="sport in filteredSports" :key="sport.id">
                        <div @click="changeSport(sport)" class="highlight-sport">
                            <svg v-if="selectedSport?.id == sport.id" class="normal-img"
                                xmlns="http://www.w3.org/2000/svg"
                                xml:space="preserve"
                                version="1.1"
                                style="width:28px; fill: none; stroke: var(--primary); shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
                                viewBox="0 0 30 25"
                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use :xlink:href="liveSportsStore.liveSportSvg(sport.id) + '#svg3108'" stroke-width="1px"  />
						    </svg>

                             <svg v-else class="normal-img"
                                xmlns="http://www.w3.org/2000/svg"
                                xml:space="preserve"
                                version="1.1"
                                style="width:28px; fill: none; stroke: grey; shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
                                viewBox="0 0 30 25"
                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use :xlink:href="liveSportsStore.liveSportSvg(sport.id) + '#svg3108'" stroke-width="1px"  />
						    </svg>



                        </div>
                    </template>
                </div>

                <div class="view-all-desktop">
                    <button @click="goToSportHighlights" class="view-all-btn">{{ $t('landing.view_all')}} </button>
                </div>
            </div>


        </div>
        <template v-if="selectedSport != null">
            <QuickPicks :sport="selectedSport"/>
        </template>
    </div>
</div>
</template>

<style scoped>
.popular-left img {
    width: 40px;
}
.eee-eimai-div {
	padding-top: 10px;
	padding-bottom: 10px;
}
.highlight-sport {
	cursor: pointer;
}

svg{
    height: 30px;
    max-width:28px;
}

.view-all-btn {
	background: transparent;
	color: var(--white);
    border: 2px solid rgba(255, 255, 255, 0.85);
    border-radius: 8px;
	font-size: 14px;
	font-weight: 500;
	letter-spacing: 0.3px;
	cursor: pointer;
	transition:
		background-color 0.25s ease,
		color 0.25s ease,
		box-shadow 0.25s ease,
		border-color 0.25s ease;
}

/* Hover */
.view-all-btn:hover {
	background-color: rgba(255, 255, 255, 0.1);
	box-shadow: 0 0 10px rgba(255, 255, 255, 0.35);
	border-color: var(--white);
}

/* Left side */
.popular-left {
	display: flex;
	align-items: center;
	gap: 10px;
}


@media (max-width: 768px) {
  .popular-games-bar {
	flex-wrap: wrap;
	row-gap: 10px;
	justify-content: center;
  }

  .featured-bottom-mobile {
		display: flex;
		justify-content: center;
		margin-top: 12px;
	}

	.view-all-desktop {
		display:none;
	}

		.popular-left img {
        width: 25px;
    }

	/* Left side */
	.popular-left {
		gap: 3px;
	}
}

/* Active */
.view-all-btn:active {
	transform: scale(0.97);
}

/* Optional: focus for accessibility */
.view-all-btn:focus-visible {
	outline: none;
	box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.4);
}

.popular-games-bar {
	/* padding-left: 5px; */
    /* padding-right: 5px; */
	display: flex;
	align-items: center;
	justify-content: space-between;
    border-bottom: 1px solid var(--secondary);
	color: var(--white);
}


.popular-icon {
	font-size: 20px;
}

.popular-title {
	font-size: 20px;
	font-weight: 600;
	letter-spacing: 0.2px;
}

/* Right side */
.popular-right {
	display: flex;
    align-items: center;
    overflow-x: scroll;
    width: 160px;
    gap: 18px;
}

/* Sport icons */
.sport-icons {
	display: flex;
	gap: 5px;
}

.sport-icon {
	font-size: 20px;
	opacity: 0.85;
	cursor: pointer;
	transition: transform 0.2s ease, opacity 0.2s ease;
}



.sport-icon:hover {
	opacity: 1;
	transform: translateY(-2px);
}

</style>